import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import MobileMenu from './MobileMenu';
import NotificationBell from './NotificationBell';
import NewsModal from './NewsModal';

import logo from '../logo.png';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const { t } = useLanguage();
  // На десктопе новости открываются модалкой, мобильное меню ведет на /news
  const [showNewsModal, setShowNewsModal] = useState(false);

  const handleLogoClick = () => {
    if (user) {
      navigate('/profile');
    } else {
      navigate('/login');
    }
  };

  const isAuthPage = location.pathname === '/login' || location.pathname === '/signup';
  const isLandingPage = location.pathname === '/';
  if ((isAuthPage || isLandingPage) && !user) {
    return null;
  }

  return (
    <header className="app-header">
      <div className="header-content">
        <div className="logo-container" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
          <img src={logo} alt="Cycling Virtual League" className="app-logo" />
        </div>
        {!user?.deactivated && (
          <nav className={`admin-nav ${user?.analytics_access ? 'admin-nav--analytics' : ''}`}>
            <button
              onClick={() => navigate('/rmc')}
              className="admin-nav-button admin-nav-button--rmc"
            >
              {t('rmc.title')}
            </button>
            {user && (
              <>
                <button
                  onClick={() => navigate('/events')}
                  className="admin-nav-button"
                >
                  {t('events.title')}
                </button>
                <button
                  onClick={() => navigate('/results')}
                  className="admin-nav-button"
                >
                  {t('results.title')}
                </button>
                <button
                  onClick={() => navigate('/ratings')}
                  className="admin-nav-button"
                >
                  {t('ratings.title')}
                </button>
                <button
                  onClick={() => navigate('/teams')}
                  className="admin-nav-button"
                >
                  {t('teams.title')}
                </button>
                <button
                  onClick={() => navigate('/users')}
                  className="admin-nav-button"
                >
                  {t('users.title')}
                </button>
                <button
                  onClick={() => navigate('/suggestions')}
                  className="admin-nav-button"
                >
                  {t('suggestions.navTitle')}
                </button>
                <button
                  onClick={() => setShowNewsModal(true)}
                  className="admin-nav-button"
                >
                  {t('news.title')}
                </button>
                {user.analytics_access && (
                  <button
                    onClick={() => navigate('/admin/analytics')}
                    className="admin-nav-button"
                  >
                    {t('admin.analytics.navTitle')}
                  </button>
                )}
              </>
            )}
          </nav>
        )}
        {user && (
          <>
            {!user.deactivated && <NotificationBell />}
            <MobileMenu />
          </>
        )}
      </div>

      <NewsModal isOpen={showNewsModal} onClose={() => setShowNewsModal(false)} />
    </header>
  );
};

export default Header;